import React, { useState } from 'react';

function Positions({ showToast }) {
  const [positions, setPositions] = useState([
    { id: 1, code: 'CEO', name: 'Tổng Giám đốc', level: 'executive', department: 'Ban Giám đốc', description: 'Quản lý điều hành toàn bộ hoạt động ngân hàng', status: 'active' },
    { id: 2, code: 'CFO', name: 'Giám đốc Tài chính', level: 'executive', department: 'Tài chính', description: 'Quản lý tài chính và kế toán', status: 'active' },
    { id: 3, code: 'CRO', name: 'Giám đốc Quản lý Rủi ro', level: 'executive', department: 'Quản lý Rủi ro', description: 'Quản lý và kiểm soát rủi ro', status: 'active' },
    { id: 4, code: 'BR-MGR', name: 'Giám đốc Chi nhánh', level: 'manager', department: 'Chi nhánh', description: 'Điều hành hoạt động chi nhánh', status: 'active' },
    { id: 5, code: 'DEPT-MGR', name: 'Trưởng phòng', level: 'manager', department: 'Các phòng ban', description: 'Quản lý phòng ban chuyên môn', status: 'active' },
    { id: 6, code: 'RM', name: 'Chuyên viên Quan hệ Khách hàng', level: 'staff', department: 'Kinh doanh', description: 'Tư vấn sản phẩm, chăm sóc khách hàng', status: 'active' },
    { id: 7, code: 'LOAN-OFF', name: 'Chuyên viên Tín dụng', level: 'staff', department: 'Tín dụng', description: 'Thẩm định và quản lý khoản vay', status: 'active' },
    { id: 8, code: 'ACC', name: 'Kế toán viên', level: 'staff', department: 'Kế toán', description: 'Hạch toán và báo cáo tài chính', status: 'active' },
    { id: 9, code: 'TELLER', name: 'Giao dịch viên', level: 'staff', department: 'Giao dịch', description: 'Thực hiện giao dịch tại quầy', status: 'active' },
    { id: 10, code: 'IT-SPT', name: 'Chuyên viên IT', level: 'staff', department: 'Công nghệ thông tin', description: 'Hỗ trợ và phát triển hệ thống', status: 'active' },
    { id: 11, code: 'RISK-ANL', name: 'Chuyên viên Phân tích Rủi ro', level: 'staff', department: 'Quản lý Rủi ro', description: 'Phân tích và đánh giá rủi ro', status: 'active' },
    { id: 12, code: 'AUDIT', name: 'Kiểm toán viên', level: 'staff', department: 'Kiểm toán', description: 'Kiểm tra tuân thủ và quy trình', status: 'active' },
  ]);

  const [searchText, setSearchText] = useState('');
  const [levelFilter, setLevelFilter] = useState('all');
  const [showModal, setShowModal] = useState(false);
  const [editingPosition, setEditingPosition] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // 'grid', 'list', 'table'
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    level: 'staff',
    department: '',
    description: '',
    status: 'active'
  });

  const filteredPositions = positions.filter(pos => {
    const matchSearch = pos.name.toLowerCase().includes(searchText.toLowerCase()) ||
                       pos.code.toLowerCase().includes(searchText.toLowerCase()) ||
                       pos.department.toLowerCase().includes(searchText.toLowerCase());
    const matchLevel = levelFilter === 'all' || pos.level === levelFilter;
    return matchSearch && matchLevel;
  });

  const openCreateModal = () => {
    setEditingPosition(null);
    setFormData({
      code: '',
      name: '',
      level: 'staff',
      department: '',
      description: '',
      status: 'active'
    });
    setShowModal(true);
  };

  const openEditModal = (position) => {
    setEditingPosition(position);
    setFormData({
      code: position.code,
      name: position.name,
      level: position.level,
      department: position.department,
      description: position.description,
      status: position.status
    });
    setShowModal(true);
  };

  const handleSave = () => {
    if (!formData.code || !formData.name || !formData.department) {
      showToast('Vui lòng điền đầy đủ thông tin bắt buộc!', 'warning');
      return;
    }

    if (editingPosition) {
      setPositions(positions.map(p => 
        p.id === editingPosition.id 
          ? { ...p, ...formData }
          : p
      ));
      showToast('Cập nhật vị trí thành công!', 'success');
    } else {
      const newPosition = {
        id: Math.max(...positions.map(p => p.id), 0) + 1,
        ...formData
      };
      setPositions([...positions, newPosition]);
      showToast('Thêm vị trí mới thành công!', 'success');
    }
    setShowModal(false);
  };

  const deletePosition = (id) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa vị trí này?')) {
      setPositions(positions.filter(p => p.id !== id));
      showToast('Xóa vị trí thành công!', 'success');
    }
  };

  const toggleStatus = (id) => {
    setPositions(positions.map(p => 
      p.id === id 
        ? { ...p, status: p.status === 'active' ? 'inactive' : 'active' }
        : p
    ));
    showToast('Cập nhật trạng thái thành công!', 'success');
  };

  const getLevelBadge = (level) => {
    const badges = {
      executive: 'bg-danger',
      manager: 'bg-warning',
      staff: 'bg-info'
    };
    const labels = {
      executive: 'Ban lãnh đạo',
      manager: 'Quản lý',
      staff: 'Nhân viên'
    };
    return <span className={`badge ${badges[level]}`}>{labels[level]}</span>;
  };

  return (
    <div className="container-fluid p-4">
      <div className="page-header-sticky">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="mb-1">
              <i className="bi bi-person-badge me-2"></i>
              Quản lý Vị trí
            </h2>
            <p className="text-muted mb-0">Quản lý các vị trí công việc trong tổ chức</p>
          </div>
          <button className="btn btn-primary" onClick={openCreateModal}>
            <i className="bi bi-plus-circle me-2"></i>
            Thêm vị trí
          </button>
        </div>
      </div>

      {/* Statistics */}
      <div className="row mb-4">
        <div className="col-md-4">
          <div className="card border-left-danger">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h6 className="text-muted">Ban lãnh đạo</h6>
                  <h3>{positions.filter(p => p.level === 'executive').length}</h3>
                </div>
                <i className="bi bi-award fs-1 text-danger"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-left-warning">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h6 className="text-muted">Quản lý</h6>
                  <h3>{positions.filter(p => p.level === 'manager').length}</h3>
                </div>
                <i className="bi bi-people fs-1 text-warning"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card border-left-info">
            <div className="card-body">
              <div className="d-flex justify-content-between">
                <div>
                  <h6 className="text-muted">Nhân viên</h6>
                  <h3>{positions.filter(p => p.level === 'staff').length}</h3>
                </div>
                <i className="bi bi-person fs-1 text-info"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Tìm kiếm theo tên, mã, phòng ban..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <select 
                className="form-select"
                value={levelFilter}
                onChange={(e) => setLevelFilter(e.target.value)}
              >
                <option value="all">Tất cả cấp bậc</option>
                <option value="executive">Ban lãnh đạo</option>
                <option value="manager">Quản lý</option>
                <option value="staff">Nhân viên</option>
              </select>
            </div>
            <div className="col-md-2">
              <div className="btn-group w-100" role="group">
                <button
                  className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('grid')}
                  title="Xem dạng lưới"
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('list')}
                  title="Xem dạng danh sách"
                >
                  <i className="bi bi-list-ul"></i>
                </button>
                <button
                  className={`btn ${viewMode === 'table' ? 'btn-primary' : 'btn-outline-secondary'}`}
                  onClick={() => setViewMode('table')}
                  title="Xem dạng bảng"
                >
                  <i className="bi bi-table"></i>
                </button>
              </div>
            </div>
            <div className="col-md-1">
              <div className="text-end">
                <span className="badge bg-info fs-6">
                  {filteredPositions.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Mã</th>
                  <th>Tên vị trí</th>
                  <th>Cấp bậc</th>
                  <th>Phòng ban</th>
                  <th>Mô tả</th>
                  <th>Trạng thái</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {filteredPositions.map(position => (
                  <tr key={position.id}>
                    <td><strong>{position.code}</strong></td>
                    <td>{position.name}</td>
                    <td>{getLevelBadge(position.level)}</td>
                    <td>{position.department}</td>
                    <td><small className="text-muted">{position.description}</small></td>
                    <td>
                      <span className={`badge ${position.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                        {position.status === 'active' ? 'Hoạt động' : 'Tạm ngưng'}
                      </span>
                    </td>
                    <td>
                      <button 
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => openEditModal(position)}
                      >
                        <i className="bi bi-pencil"></i>
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-warning me-2"
                        onClick={() => toggleStatus(position.id)}
                      >
                        <i className="bi bi-toggle-on"></i>
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => deletePosition(position.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingPosition ? 'Cập nhật vị trí' : 'Thêm vị trí mới'}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Mã vị trí <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.code}
                      onChange={(e) => setFormData({...formData, code: e.target.value})}
                      placeholder="VD: RM, TELLER"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Tên vị trí <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      placeholder="VD: Giao dịch viên"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Cấp bậc</label>
                    <select 
                      className="form-select"
                      value={formData.level}
                      onChange={(e) => setFormData({...formData, level: e.target.value})}
                    >
                      <option value="executive">Ban lãnh đạo</option>
                      <option value="manager">Quản lý</option>
                      <option value="staff">Nhân viên</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Phòng ban <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formData.department}
                      onChange={(e) => setFormData({...formData, department: e.target.value})}
                      placeholder="VD: Kinh doanh"
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Mô tả công việc</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={formData.description}
                      onChange={(e) => setFormData({...formData, description: e.target.value})}
                      placeholder="Mô tả chi tiết về công việc và trách nhiệm"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Trạng thái</label>
                    <select 
                      className="form-select"
                      value={formData.status}
                      onChange={(e) => setFormData({...formData, status: e.target.value})}
                    >
                      <option value="active">Hoạt động</option>
                      <option value="inactive">Tạm ngưng</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Hủy
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  <i className="bi bi-save me-2"></i>
                  Lưu
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Positions;
